import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: ${props => props.theme.colors.background.primary};
  transition: background 0.3s ease;
`

export const Toolbar = styled.div`
  width: 100%;
  height: ${({ height }) => height || 'auto'};
  display: flex;
  align-items: center;
  justify-content: ${({ isend }) => isend ? 'flex-end' : 'space-between'};
  margin-top: ${({ margintop }) => margintop || '0px'};
  padding: 0.75rem 1.5rem;
  gap: 1rem;
  background: transparent;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
    padding: 0.75rem 1rem;
  }
`

export const ToolbarItem = styled.div`
  height: ${({ height }) => height || '100%'};
  display: flex;
  margin-top: ${({ margintop }) => margintop || '0px'};
  justify-content: center;
  align-items: center;
  gap: ${({ gap }) => gap || '1rem'};

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 0.5rem;
  }
`

export const Loginbox = styled.div`
  width: 100%;
  max-width: 400px;
  min-width: 320px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 2.5rem 2rem;
  border-radius: ${props => props.theme.radius.card};
  border: 1px solid ${props => props.theme.colors.border.medium};
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.light};
  background: ${props => props.theme.colors.background.primary};
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.medium};
  }

  @media (max-width: 480px) {
    margin: 20px;
    padding: 32px 24px;
    min-width: auto;
  }
`

export const Logo = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 1.5rem;
  border-radius: 50%;
  box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.medium};
  border: 2px solid ${props => props.theme.colors.background.tertiary};
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px ${props => props.theme.colors.shadow.strong};
  }
`

export const LoginLabel = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  margin: 0.5rem 0;
  padding: 0.75rem 1rem;
  border: 1px solid ${props => props.theme.colors.border.medium};
  border-radius: ${props => props.theme.radius.input};
  background-color: ${props => props.theme.colors.background.primary};
  font-size: ${props => props.theme.typography.fontSize.input};
  font-weight: 400;
  font-family: ${props => props.theme.typography.fontFamily};
  color: ${props => props.theme.colors.text.primary};
  outline: none;
  transition: all 0.2s ease;
  position: relative;

  &::placeholder {
    color: ${props => props.theme.colors.text.muted};
    font-weight: 300;
  }

  &:focus {
    border-color: ${props => props.theme.colors.border.focus};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.shadow.focus};
  }

  &:hover:not(:focus) {
    border-color: ${props => props.theme.colors.text.tertiary};
    background: ${props => props.theme.colors.background.hover};
  }
`

export const PasswordWrapper = styled.div`
  position: relative;
  width: 100%;
`

export const EyeIcon = styled.div`
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: ${props => props.theme.colors.text.muted};
  font-size: 1rem;
  transition: all 0.2s ease;
  padding: 0.25rem;
  border-radius: 4px;

  &:hover {
    color: ${props => props.theme.colors.text.tertiary};
  }
`

export const LoginFormButton = styled.button`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.75rem;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
  border: none;
  border-radius: ${props => props.theme.radius.button};
  background: ${({ outline, theme }) => outline ? 'transparent' : theme.colors.semantic.primary};
  color: ${({ outline, theme }) => outline ? theme.colors.text.primary : theme.colors.text.inverse};
  border: ${({ outline, theme }) => outline ? `1px solid ${theme.colors.semantic.primary}` : 'none'};
  font-size: ${props => props.theme.typography.fontSize.button};
  font-weight: ${props => props.theme.typography.fontWeight.button};
  font-family: ${props => props.theme.typography.fontFamily};
  outline: none;
  cursor: pointer;
  transition: ${props => props.theme.transitions.button};
  position: relative;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px ${props => props.theme.colors.shadow.medium};
    ${({ outline, theme }) => outline && `
      background: ${theme.colors.semantic.primary};
      color: ${theme.colors.text.inverse};
    `}
    ${({ outline, theme }) => !outline && `
      background: ${theme.colors.text.secondary};
    `}
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 1px 2px ${props => props.theme.colors.shadow.light};
  }

  &:disabled {
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
    opacity: 0.5;
    background: ${props => props.theme.colors.background.disabled};
    color: ${props => props.theme.colors.text.muted};
    border-color: ${props => props.theme.colors.border.light};

    &:hover {
      transform: none;
      box-shadow: none;
      background: ${props => props.theme.colors.background.disabled};
    }
  }
`

export const ForgotPasswordLink = styled.div`
  text-decoration: none;
  color: ${props => props.theme.colors.text.tertiary};
  font-size: 0.75rem;
  font-weight: 400;
  font-family: ${props => props.theme.typography.fontFamily};
  cursor: pointer;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  transition: ${props => props.theme.transitions.default};
  padding: 0.5rem 1rem;
  border-radius: ${props => props.theme.radius.input};
  position: relative;

  &:hover {
    color: ${props => props.theme.colors.text.primary};
    background-color: ${props => props.theme.colors.background.hover};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0.25rem;
    left: 1rem;
    right: 1rem;
    height: 1px;
    background: ${props => props.theme.colors.text.primary};
    transform: scaleX(0);
    transition: transform 0.2s ease;
  }

  &:hover::after {
    transform: scaleX(1);
  }
`

export const Logout = styled.div`
  width: auto;
  display: flex;
  flex-wrap: wrap;
  justify-items: center;
  gap: 20px;
`
